import React from 'react';
import { Badge } from './ui/badge';
import { MessageSquare, Edit3 } from 'lucide-react';

const TypingIndicator = ({ typingUsers = [], context = 'task', className = '' }) => {
  if (typingUsers.length === 0) return null;

  const getContextIcon = () => {
    switch (context) {
      case 'comment':
        return <MessageSquare className="w-3 h-3" />;
      case 'task':
        return <Edit3 className="w-3 h-3" />;
      default:
        return <Edit3 className="w-3 h-3" />;
    }
  };

  const getTypingText = () => {
    const names = typingUsers.map(user => user.user_name || user.name);
    
    if (names.length === 1) {
      return `${names[0]} is typing...`;
    } else if (names.length === 2) {
      return `${names[0]} and ${names[1]} are typing...`;
    } else if (names.length === 3) {
      return `${names[0]}, ${names[1]} and ${names[2]} are typing...`;
    } else {
      return `${names[0]} and ${names.length - 1} others are typing...`;
    }
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200 animate-pulse">
        {getContextIcon()}
        <span className="ml-1 text-xs">{getTypingText()}</span>
      </Badge>
    </div>
  );
};

export default TypingIndicator;